import { ref } from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
import 'moment/locale/fr'
import zhCN from '../locales/zh-CN.json'
import enUS from '../locales/en-US.json'
import frFR from '../locales/fr-FR.json'

export type Lang = 'zh-CN' | 'en-US' | 'fr-FR'

export const currentLocale = ref<Lang>(
  (localStorage.getItem('lang') as Lang) || 'zh-CN'
)

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'fr-FR': frFR
} as const

export const langMap = {
        'zh-CN': 'zh',
        'en-US': 'en',
        'fr-FR': 'fr'
    }

const indices = new Map<Lang, Map<string, string>>()

function buildIndex(obj: any, index: Map<string, string>, path: string = '') {
  for (const key in obj) {
    const currentPath = path ? `${path}.${key}` : key
    const value = obj[key]
    if (typeof value === 'string') {
      index.set(value, currentPath)
    } else if (typeof value === 'object' && value !== null) {
      buildIndex(value, index, currentPath)
    }
  }
}

const zhIndex = new Map<string, string>()
buildIndex(messages['zh-CN'], zhIndex)
indices.set('zh-CN', zhIndex)

function getByPath(obj: any, path: string) {
  return path.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj)
}

function getIndex(lang: Lang): Map<string, string> {
  if (indices.has(lang)) {
    return indices.get(lang)!
  }
  const index = new Map<string, string>()
  buildIndex(messages[lang], index)
  indices.set(lang, index)
  return index
}

export function t(key: string): string {
  const v = getByPath(messages[currentLocale.value], key)
  return typeof v === 'string' ? v : key
}

export function setLang(lang: Lang) {
  currentLocale.value = lang
  localStorage.setItem('lang', lang)
  moment.locale(lang === 'zh-CN' ? 'zh-cn' : lang === 'fr-FR' ? 'fr' : 'en')
}

export function findTranslationByChinese(text: string, targetLang?: Lang): string  {
  console.log(text)
  if (currentLocale.value === "zh-CN") return text
  const chineseRegex = /[\u4e00-\u9fa5]+/g
  if (!chineseRegex.test(text)) return text
  const lang = targetLang ?? currentLocale.value
  const replaced = text.replace(chineseRegex, (seg) => {
    const path = zhIndex.get(seg)
    if (!path) return seg
    const v = getByPath(messages[lang], path)
    return typeof v === 'string' ? v : seg
  })
  return replaced
}

export function findChineseTranslationByForeign(text: string, sourceLang?: Lang): string  {
  const lang = sourceLang || currentLocale.value
  if (lang === 'zh-CN') return text
  
  const index = getIndex(lang)
  const path = index.get(text)
  if (!path) return text
  
  const v = getByPath(messages['zh-CN'], path)
  return typeof v === 'string' ? v : text
}

export function findTranslation(text: string, sourceLang?: Lang): string {
  const lang = sourceLang || currentLocale.value
  if (lang === 'zh-CN') return text
  const path = zhIndex.get(text)
  if (!path) return text
  const v = getByPath(messages[lang], path)
  return typeof v === 'string' ? v : text
}

export default { t, setLang, currentLocale, findTranslationByChinese, findChineseTranslationByForeign, findTranslation }
